import React, { useEffect, useRef, useState } from "react";
import { Wordmark } from "./FyllrMark";

const SEEN_KEY = "fyllr_intro_v2";
let introDismissed = false;

const VIDEO_SRC = "https://customer-assets-39nsmqrw.emergentagent.net/job_last-minute-lux/artifacts/c60566993c863187_FYLLR_Deep_Wine_Mobile.mp4";

/* Brand video intro — plays the FYLLR Deep Wine film, then dissolves into the site.
   Scroll / swipe / tap skip to enter early. Falls back gracefully if the video can't play. */
function LiquidIntro() {
  const reduce = typeof window !== "undefined" &&
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const alreadySeen = typeof window !== "undefined" && sessionStorage.getItem(SEEN_KEY);

  const [mounted, setMounted] = useState(!alreadySeen && !introDismissed && !reduce);
  const [leaving, setLeaving] = useState(false);
  const leavingRef = useRef(false);

  const enter = () => {
    if (leavingRef.current) return;
    leavingRef.current = true;
    introDismissed = true;
    setLeaving(true);
    try { sessionStorage.setItem(SEEN_KEY, "1"); } catch (e) {}
    setTimeout(() => setMounted(false), 900);
  };

  useEffect(() => {
    if (!mounted) { document.body.style.overflow = ""; return; }
    document.body.style.overflow = "hidden";
    // Safety: never trap the visitor if the video stalls.
    const safety = setTimeout(enter, 14000);
    return () => { document.body.style.overflow = ""; clearTimeout(safety); };
  }, [mounted]);

  // enter gestures
  useEffect(() => {
    if (!mounted) return;
    let startY = null;
    const onWheel = (e) => { if (e.deltaY > 6) enter(); };
    const onTouchStart = (e) => { startY = e.touches[0].clientY; };
    const onTouchMove = (e) => { if (startY !== null && startY - e.touches[0].clientY > 32) enter(); };
    window.addEventListener("wheel", onWheel, { passive: true });
    window.addEventListener("touchstart", onTouchStart, { passive: true });
    window.addEventListener("touchmove", onTouchMove, { passive: true });
    return () => {
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("touchstart", onTouchStart);
      window.removeEventListener("touchmove", onTouchMove);
    };
  }, [mounted]); // eslint-disable-line

  if (!mounted) return null;

  return (
    <div className={`fyllr-intro ${leaving ? "is-leaving" : ""}`} data-testid="liquid-intro">
      <video
        className="fyllr-intro-video"
        src={VIDEO_SRC}
        autoPlay
        muted
        playsInline
        preload="auto"
        onEnded={enter}
        onError={enter}
        data-testid="intro-video"
      />
      <div className="fyllr-intro-vignette" aria-hidden="true" />

      <div className="fyllr-intro-content" data-testid="intro-content">
        <Wordmark size="xl" color="#F6F0E8" className="fyllr-intro-logo" />
        <p className="fyllr-intro-tag">Beauty · Grooming · Wellness</p>
      </div>

      <button className="fyllr-intro-skip" onClick={enter} data-testid="intro-skip">Skip intro ↗</button>

      <button className="fyllr-intro-enter-hint" onClick={enter} data-testid="intro-enter">
        <span>Scroll to enter</span>
        <span className="fyllr-intro-chev">↑</span>
      </button>
    </div>
  );
}

export default React.memo(LiquidIntro);
